// src/api/axiosInstance.js
import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  headers: { 'Content-Type': 'application/json' },
})

// // Example request interceptor: add token if available
// axiosInstance.interceptors.request.use((config) => {
//   const token = localStorage.getItem('token') // change to your auth logic
//   if (token) config.headers.Authorization = `Bearer ${token}`
//   return config
// }, (error) => Promise.reject(error))

export default axiosInstance